
export const SystemUserId: number = 1;
export const AdminContactEmail: string = "ugportaladmin@amer.mhps.com";
export const PrivacyPolicy: string = "https://amermhi.com/files/USERS_GROUP_PRIVACY_POLICY.pdf";
export const TermsOfUse: string = "https://amermhi.com/files/USERS_GROUP_TERMS_OF_USE_AND_GENERAL_DISCLAIMER.pdf";